import styled from 'styled-components';

const ICON_SIZES = {
    sm: { container: 28, img: 14 },
    md: { container: 36, img: 18 },
    lg: { container: 44, img: 22 },
};

const LOGO_SIZES = {
    sm: { height: 28, imgHeight: 14 },
    md: { height: 34, imgHeight: 16 },
    lg: { height: 40, imgHeight: 20 },
};

export const IconBtnContainer = styled.button`
    align-items: center;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
    line-height: 0;
    transition: background 0.15s ease-out, border-color 0.15s ease-out;

    /* icon variant: perfect circle */
    ${({ $variant = 'icon', $size = 'md' }) => $variant === 'icon' && `
        width: ${ICON_SIZES[$size]?.container ?? ICON_SIZES.md.container}px;
        height: ${ICON_SIZES[$size]?.container ?? ICON_SIZES.md.container}px;
        padding: 0;

        > svg, > img {
            display: block;
            height: ${ICON_SIZES[$size]?.img ?? ICON_SIZES.md.img}px;
            width: ${ICON_SIZES[$size]?.img ?? ICON_SIZES.md.img}px;
        }
    `}

    /* logo variant: auto-width, full-height image */
    ${({ $variant, $size = 'md' }) => $variant === 'logo' && `
        height: ${LOGO_SIZES[$size]?.height ?? LOGO_SIZES.md.height}px;
        padding: 0 12px;
        width: auto;

        > svg, > img {
            display: block;
            height: ${LOGO_SIZES[$size]?.imgHeight ?? LOGO_SIZES.md.imgHeight}px;
            width: auto;
        }
    `}

    &:hover {
        background: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.67);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    > * {
        pointer-events: none;
    }
`;

export const IconBtnMenu = styled.div`
    background: transparent;
    border: none;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    overflow: visible;
    position: fixed;
    width: 180px;
    z-index: 10001;
    max-height: calc(100vh - 20px);
`;

export const IconBtnMenuContent = styled.div`
    background-color: transparent;

    div {
        height: 8px;
    }

    ul {
        background-color: rgba(255,255,255,0.2);
        border-radius: 12px;
        list-style-type: none;
        margin: 0;
        padding: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
`;

export const IconBtnMenuItem = styled.li`
    cursor: pointer;
    list-style: none;
    border-radius: 8px;
    color: #FFFFFF;
    padding: 12px 16px;
    transition: background-color 0.2s ease-in-out;
    user-select: none;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;